const PropTypes = require('prop-types');
// @vendors
const React = require('react');

// @ utils
const { formatText } = require('core/i18n').i18n;

// @ commons
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');

// @ local
const { BrokerAdvancedSearchStocksResultsRow } = require('./stocksResultsRow');

class BrokerAdvancedSearchStocksResultsTable extends React.Component {
    constructor(props) {
        super(props);

        this.handleProductSelect = this.handleProductSelect.bind(this);
    }

    handleProductSelect(product) {
        this.props.onHandleProductSelect(product);
    }

    tableHeaders() {
        const PREFIX = 'broker-searchResults';
        const nameLabel = formatText(`${PREFIX}NameLabel`);
        const ytdLabel = formatText(`${PREFIX}YtdLabel`);
        const currencyLabel = formatText(`${PREFIX}CurrencyLabel`);
        const marketLabel = formatText(`${PREFIX}MarketLabel`);
        const priceLabel = formatText(`${PREFIX}PriceLabel`);
        const dailyVariationLabel = formatText(`${PREFIX}DailyVariationLabel`);

        return (
            <OKTableRow asHeader={true} className="broker-search-results__table-header">
                <OKTableCell
                    asHeader={true}
                    className="broker-search-results__table-first-column"
                    width="26%"
                >
                    {nameLabel}
                </OKTableCell>
                <OKTableCell
                    alignment="right"
                    asHeader={true}
                    className="broker-search-results__table-header-cell--stock-price"
                    width="10%"
                >
                    {priceLabel}
                </OKTableCell>
                <OKTableCell
                    asHeader={true}
                    width="18%"
                >
                    {marketLabel}
                </OKTableCell>
                <OKTableCell
                    asHeader={true}
                    width="3%"
                >
                    {currencyLabel}
                </OKTableCell>
                <OKTableCell
                    alignment="right"
                    asHeader={true}
                    width="13%"
                >
                    {dailyVariationLabel}
                </OKTableCell>
                <OKTableCell
                    alignment="right"
                    asHeader={true}
                    width="5%"
                >
                    {ytdLabel}
                </OKTableCell>
                <OKTableCell
                    asHeader={true}
                    className="broker-search-results__table-header-cell--action"
                    width="10%"
                />
            </OKTableRow>
        );
    }

    tableRows(results) {
        const tableRows = results.map((result,index) => {
            const uniqueId = result.get('productKey');
            return this.props.isModal
                ? <BrokerAdvancedSearchStocksResultsRow
                    key={uniqueId}
                    item={result}
                    isModal={this.props.isModal}
                    onHandleProductSelect={this.handleProductSelect}
                    onBuyClick={this.props.onHandleProductBuy}
                    onWatchlistClick={this.props.onHandleWatchlistAdd}
                    deleteProductFromList={this.props.deleteProductFromList}
                    rowIndex={index}
                    watchlistEnabled={this.props.watchlistEnabled}
                  />
                : <BrokerAdvancedSearchStocksResultsRow key={uniqueId}
                    item={result}
                    onBuyClick={this.props.onHandleProductBuy}
                    onWatchlistClick={this.props.onHandleWatchlistAdd}
                    deleteProductFromList={this.props.deleteProductFromList}
                    rowIndex={index}
                    watchlistEnabled={this.props.watchlistEnabled}
                  />;
        });

        return tableRows;
    }

    render() {
        const { results  } = this.props;

        const tableHeaders = this.tableHeaders();
        const tableRows = this.tableRows(results);

        /**
         * @horizontal-scroll
         *
         * The result table has a container with an horizontal scroll and the
         * inner content is set to a fix width according to its size in
         * desktop.
         */

        return (
            <div className="broker-search-results__table-wrapper" style={{ overflowX: 'auto' }}>
                <OKTable className="broker-search-results__table">
                    <thead>
                        {tableHeaders}
                    </thead>
                    <tbody>
                        {tableRows}
                    </tbody>
                </OKTable>
            </div>
        );
    }
}

BrokerAdvancedSearchStocksResultsTable.propTypes = {
    results: PropTypes.object,
    isModal: PropTypes.bool,
    onHandleProductSelect: PropTypes.func,
    onHandleProductBuy: PropTypes.func,
    selectedType: PropTypes.string,
    onHandleWatchlistAdd: PropTypes.func,
    deleteProductFromList: PropTypes.func,
    watchlistEnabled: PropTypes.bool,
};


module.exports = BrokerAdvancedSearchStocksResultsTable;
